//  ハンバーガーからリンク飛んだらメニュー閉じる
$(function () {
  var $header = $('#js-header');
  $('#js-menu').on('click', function (e) {
    e.preventDefault();
    $header.toggleClass('is-open');
    $(".l-headerDrawerWrapper").fadeToggle();
  });

  $(".js-menu").on('click', function () {
    $(this).parent().toggleClass('is-open');
  });

  $('.js-acdn__content').hide();
  $('.c-qa__q--acordion,.js-acdn,.c-pageTitle__h3Acdn,.c-acdn').on('click', function () {
    $(this).toggleClass('active');
    $(this).next('.js-acdn__content').slideToggle();
  });


});

$('a[href^="#"]').on('click', function () {
  var adjust = 140;
  if (window.matchMedia('(max-width: 600px)').matches) {
    var adjust = 100;
  }
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "./" ? 'html' : href);
  var position = target.offset().top - adjust;
  $("html, body").animate({ scrollTop: position }, 500, "swing");
  return false;
});

if (window.matchMedia('(max-width: 1024px)').matches) {
  $(function () {
    $('.l-headerDrawerCol__pageP > p').click(function () {
      $(this).next('ul').slideToggle();
      $(this).parent().toggleClass('js-child-open');
    });
  });
}

// /staff/sd 最新年度のみ修正
$(function() {
    $('.js-acdn__contentBlock').hide();
        let tg = (s)=>{ $(s).toggleClass('active').next().slideToggle(); };
    $('.js-acdnBlock').click(function() {
        if(!$(this).hasClass('active')) tg('.js-acdnBlock.active');
            $('.js-acdnBlock').toggleClass('active');
            tg(this);
        }).eq(0).click()

            $('.js-acdn__contentBlock2').hide();
        let tg2 = (s)=>{ $(s).toggleClass('active').next().slideToggle(); };
    $('.js-acdnBlock2').click(function() {
        if(!$(this).hasClass('active')) tg2('.js-acdnBlock2.active');
            $('.js-acdnBlock2').toggleClass('active');
            tg2(this);
    }).eq(0).click()

        $('.js-acdn__contentBlock3').hide();
        let tg3 = (s)=>{ $(s).toggleClass('active').next().slideToggle(); };
    $('.js-acdnBlock3').click(function() {
        if(!$(this).hasClass('active')) tg3('.js-acdnBlock3.active');
            $('.js-acdnBlock3').toggleClass('active');
            tg3(this);
    }).eq(0).click()
});

// ハンバーガーのオープン時背景スクロールを禁止
$(function(){
    $('.c-tab li:first-of-type').addClass("active");
    $('.js-tab_area:first-of-type').addClass("active");
    $('.c-tab__list').on('click', function(){
        let index = $('.c-tab__list').index(this);

        $('.c-tab__list').removeClass('active');
        $(this).addClass('active');
        $('.js-tab_area').removeClass('active');
        $('.js-tab_area').eq(index).addClass('active');
    }); 

    var state = false;
    var pos;
    $('#js-menu').click(function(){
    if (state == false) {
        pos = $(window).scrollTop();
        $('body').addClass('fixed').css({'top': -pos});
        state = true;
    } else {
        $('body').removeClass('fixed').css({'top': 0});
            window.scrollTo(0, pos);
            state = false;
        }
    });
});

// ヘッダー box-shadow
$(window).on('scroll', function() {
    var mv = 100;
    if(window.innerWidth > 1024) {
        var mv = 60;
    }
    
    var scroll = $(window).scrollTop();
    if (scroll >= mv){
        $('#js-header').addClass('scroll');
    } else {
        $('#js-header').removeClass('scroll');
    }
});

// ある程度スクロールしたあたりからTOPに戻るボタンを表示
$(window).scroll(function (){
    $('.js-backBtn').each(function(){
        // TOPからのスクロール
        var elemPos = $(this).offset().top;

        if(window.innerWidth > 600) {    
            if (elemPos > 800) {
                $(this).addClass('scroll');
            } else {
                $(this).removeClass('scroll');
            }
        } else {
            if (elemPos > 750) {
                $(this).addClass('scroll');
            } else {
                $(this).removeClass('scroll');
            }
        }
    });
});